import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { solarIcon } from "assets/images";
ChartJS.register(ArcElement, Tooltip, Legend);

const shadowPlugin = {
  id: "shadowPlugin",
  beforeDraw: (chart) => {
    const { ctx } = chart;
    const arcs = chart.getDatasetMeta(0).data;
    arcs.forEach((arc) => {
      const originalDraw = arc.draw;
      arc.draw = function () {
        ctx.save();
        ctx.shadowColor = "rgba(0, 0, 0, 0.15)";
        ctx.shadowBlur = 10;
        ctx.shadowOffsetX = 0;
        ctx.shadowOffsetY = 4;
        originalDraw.apply(this, arguments);
        ctx.restore();
      };
    });
  },
};
// Plugin for variable radius (can be omitted if even thickness preferred)
const variableRadiusPlugin = {
  id: "variableRadiusPlugin",
  beforeDraw(chart) {
    const datasetMeta = chart.getDatasetMeta(0);
    const innerRadius = datasetMeta.controller.innerRadius;
    const outerRadius = datasetMeta.controller.outerRadius;
    const heightOfItem = outerRadius - innerRadius;
    const countOfData = datasetMeta.data.length;
    const additionalRadius = Math.floor(heightOfItem / countOfData);
    const weightsMap = datasetMeta.data
      .map((v) => v.circumference)
      .sort((a, b) => a - b)
      .reduce((acc, val, idx) => {
        acc.set(val, idx + 1);
        return acc;
      }, new Map());
    datasetMeta.data.forEach((dataItem) => {
      const weight = weightsMap.get(dataItem.circumference);
      dataItem.outerRadius = (innerRadius + additionalRadius * (weight / 2) + 30);
    });
  },
};
const CustomDonutChart = ({ powerConsumptionPie }) => {
  // console.log('powerConsumptionPie', powerConsumptionPie)

  const solar = parseFloat(powerConsumptionPie?.solar || 0);
  const dg = parseFloat(powerConsumptionPie?.dg || 0);
  const grid = parseFloat(powerConsumptionPie?.grid || 0);

  const data = {
    labels: ["Solar", "DG", "Grid"],
    datasets: [
      {
        data: [solar, dg, grid],
        backgroundColor: ["#FFD166", "#C084FC", "#70D6FF"],
        borderWidth: 0,
        hoverOffset: 8,
        borderRadius: 2,
      },
    ],
  };

  const options = {
    cutout: "60%",
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
    },
  };
  return (
    <div className="custom_donut_chart_wrap">
      <div
        style={{
          width: 300,
          height: 300,
          position: "relative",
          margin: "auto",
          borderRadius: "50%",
        }}
      >
        {" "}
        <Doughnut
          data={data}
          options={options}
          plugins={[variableRadiusPlugin, shadowPlugin]}
        />
        {/* Center circle for icon or label */}{" "}
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 120,
            height: 120,
            borderRadius: "50%",
            background: "#fff",
            boxShadow: "inset 0 4px 8px rgba(0,0,0,0.05)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          {/* Replace with your icon */}
          <img src={solarIcon} alt="solar" style={{ width: 55, height: 55 }} />
        </div>{" "}
      </div>

      <div className="chart_data">
        <ul>
          <li>
            <span>Solar</span>
            <b>{solar}%</b>
          </li>
          <li>
            <span>DG</span>
            <b>{dg}%</b>
          </li>
          <li>
            <span>Grid</span>
            <b>{grid}%</b>
          </li>

        </ul>
      </div>
    </div>
  );
};
export default CustomDonutChart;
